export default __webpack_public_path__ + "static/media/meeting.0c78d6c4.svg";